<template>
  <b-modal
    :id="modalId"
    centered
    size="xl"
    title="Novo Cliente"
    hide-footer
    body-class="p-0 novo-cliente-modal-body"
    @hidden="resetNovoClienteModal"
  >
    <PessoaForm
      url="/pessoa/create"
      :pessoa="novaPessoa"
      :hide-tipo-pessoa="true"
      :force-cliente="true"
      :redirect-on-save="false"
      @saved="handleNovoClienteSaved"
      @cancel="$bvModal.hide(modalId)"
    />
  </b-modal>
</template>

<script>
import PessoaForm from "@/modules/Pessoa/pages/Form.vue";
import PessoaData from "@/modules/Pessoa/pages/PessoaData";
import { SistemaMixin } from "@/modules/Application";

export default {
  name: "app-novo-cliente-modal",
  components: {
    PessoaForm,
  },
  mixins: [SistemaMixin],
  props: {
    modalId: {
      type: String,
      required: true,
    },
    successMessage: {
      type: String,
      default: "Cliente cadastrado e selecionado!",
    },
    unresolvedMessage: {
      type: String,
      default:
        "Cliente cadastrado, mas não foi possível selecioná-lo automaticamente.",
    },
  },
  data() {
    return {
      novaPessoa: new PessoaData({}),
    };
  },
  methods: {
    resetNovoClienteModal() {
      this.novaPessoa = new PessoaData({});
    },
    async handleNovoClienteSaved({ response, form }) {
      try {
        const cliente = await this.resolveClienteCriado(response, form);

        if (!cliente?.id_pessoa) {
          this.$toast.warning(this.unresolvedMessage);
          this.$bvModal.hide(this.modalId);
          this.$emit("saved", { response, form, cliente: null });
          return;
        }

        const clienteNormalizado = this.normalizeClienteCriado(cliente, form);

        this.$bvModal.hide(this.modalId);
        this.$emit("selected", clienteNormalizado);
        this.$emit("saved", { response, form, cliente: clienteNormalizado });
        this.$toast.success(this.successMessage);
      } catch {
        this.$toast.error(
          "Cliente cadastrado, mas houve erro ao selecioná-lo."
        );
      }
    },
    async resolveClienteCriado(response, form) {
      const responseData = response?.data ?? response;
      const id_pessoa = responseData?.id_pessoa ?? responseData?.id;
      const cliente =
        responseData?.pessoa ??
        responseData?.cliente ??
        responseData?.data ??
        responseData;

      const clienteBuscaPadrao = await this.findClienteNaBuscaPadrao({
        id_pessoa: cliente?.id_pessoa ?? id_pessoa,
        cnpj_cpf: cliente?.cnpj_cpf ?? form?.cnpj_cpf,
        nome: cliente?.nome ?? form?.nome,
      });

      if (clienteBuscaPadrao?.id_pessoa) return clienteBuscaPadrao;

      if (cliente?.id_pessoa) {
        if (this.getEnderecosCliente(cliente).length > 0) return cliente;

        const clienteCompleto = await this.findClienteById(cliente.id_pessoa);
        return clienteCompleto ?? cliente;
      }

      if (id_pessoa) {
        return await this.findClienteById(id_pessoa);
      }

      const clientes = await this.getClientes(form?.nome ?? "");
      return clientes.find((item) => item.nome === form?.nome) ?? clientes[0];
    },
    async findClienteNaBuscaPadrao({ id_pessoa, cnpj_cpf, nome }) {
      const termosBusca = [cnpj_cpf, nome].filter(Boolean);
      if (termosBusca.length === 0) return null;

      for (let tentativa = 0; tentativa < 3; tentativa++) {
        for (const termoBusca of termosBusca) {
          const clientes = await this.getClientes(termoBusca);
          const clienteEncontrado =
            clientes.find((item) => item.id_pessoa === id_pessoa) ??
            clientes.find((item) => item.cnpj_cpf === cnpj_cpf) ??
            clientes.find((item) => item.nome === nome) ??
            clientes[0] ??
            null;

          if (clienteEncontrado?.id_pessoa) return clienteEncontrado;
        }

        await this.$nextTick();
      }

      return null;
    },
    async findClienteById(id_pessoa) {
      const { data } = await this.$http.post("/pessoa/find", {
        id_pessoa,
      });

      return data?.pessoa ?? data?.data ?? data;
    },
    getEnderecosCliente(cliente) {
      if (!cliente) return [];

      if (Array.isArray(cliente.enderecos) && cliente.enderecos.length > 0) {
        return cliente.enderecos;
      }

      if (Array.isArray(cliente.endereco) && cliente.endereco.length > 0) {
        return cliente.endereco;
      }

      if (cliente.endereco && !Array.isArray(cliente.endereco)) {
        return [cliente.endereco];
      }

      return [];
    },
    normalizeClienteCriado(cliente, form) {
      const enderecos = this.getEnderecosCliente(cliente);
      const enderecosForm = this.getEnderecosCliente(form);
      const enderecosNormalizados =
        enderecos.length > 0 ? enderecos : enderecosForm;

      return {
        ...cliente,
        enderecos: enderecosNormalizados,
        endereco: enderecosNormalizados[0] || null,
      };
    },
  },
};
</script>
